import { acceptHMRUpdate, defineStore } from "pinia";

export const useSettingsPanel = defineStore("ui/settings", {
  state: () => ({
    settingsPaneOpen: false,
    languageSettingsOpen: false
  }),

  actions: {
    /**
     * Opens or closes the settings bar.
     */
    setSettingsPaneOpen(open: boolean) {
      if (open) {
        this.$patch((state) => {
          state.languageSettingsOpen = false;
          state.settingsPaneOpen = true;
        });
      } else {
        this.settingsPaneOpen = false;
      }
    },
    /**
     * Opens or closes the language settings.
     */
    setLanguageSettingsOpen(open: boolean) {
      if (open) {
        this.$patch((state) => {
          state.languageSettingsOpen = true;
          state.settingsPaneOpen = false;
        });
      } else {
        this.languageSettingsOpen = false;
      }
    }
  }
});

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useSettingsPanel, import.meta.hot));
}
